import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Stylesheets/Monthtimeline.css";



import AOS from "aos";

const timelineData = [
  {
    time: "Onboarding",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img98115_IMG.png",
    title: "Offer Letter & Onboarding",
    description: [
      "Provided only after successful completion of training and evaluation.",
      "Marks official employment start.",
    ],
    badges: [{ text: "Employment Start", color: "primary" }],
  },
  {
    time: "Salary",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img25576_IMG.png",
    title: "Salary Structure",
    description: [
      "Based on your performance",
      "Performance-based increments after certification or outstanding project work.",
    ],
    badges: [{ text: "Compensation", color: "success" }],
  },
  {
    time: "Benefits",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img80676_IMG.png",
    title: "Performance-Based Benefits",
    description: [
      "Employees completing certification courses in their domain are rewarded with higher salary.",
      "Future hike of 50% for rejoining employees after completion, when company has openings.",
    ],
    badges: [{ text: "Growth", color: "warning text-dark" }],
  },
  {
    time: "Agreement",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img46907_IMG.png",
    title: "Service Agreement",
    description: [
      "Mandatory 1-year bond/agreement to ensure stability and commitment.",
      "Breaking the bond may result in withholding of experience certificate.",
    ],
    badges: [{ text: "Commitment", color: "danger" }],
  },
  {
    time: "Projects",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img80818_IMG.png",
    title: "Live Projects",
    description: [
      "Employees work on real-time projects for company clients.",
      "Exposure to project lifecycle: requirement analysis, development, testing, deployment, and maintenance.",
    ],
    badges: [{ text: "Practical Work", color: "info" }],
  },
  {
    time: "Certification",
    icon: "https://d242nlqul83u9g.cloudfront.net/adminpanel/carrermate/img81399_IMG.png",
    title: "Certification & Experience",
    description: [
      "After completion of 1 year, employees receive:",
      "Experience Certificate (for employment record).",
      "Completion Certificate (for training + employment record).",
    ],
    badges: [{ text: "Recognition", color: "secondary" }],
  },
];

const Month7 = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo({ behavior: "smooth", top: 0 });
  }, []);

  return (
    <section
      id="monthtimeline"
      className="min-vh-100 position-relative overflow-hidden"
    >
      {/* Background Video */}
      {/* <div className="home-bg">
        <video loop autoPlay muted playsInline>
          <source src={bg_video} />
        </video>
        <div className="video-overlay"></div>
      </div> */}

      <div className="container text-light position-relative">
        <h1
          className="text-center py-3 mt-5 fw-bold gradient-text monthtimeline"
          style={{ fontFamily: "'Merriweather', serif" }}
        >
          1 Year Placement Period
        </h1>
        <div className="timeline">
          {timelineData.map((item, index) => (
            <div className="timeline-row" data-aos="fade-up" key={index}>
              <div
                className="timeline-time text-light fw-bold"
                data-aos="zoom-in-up"
              >
                {item.time}
              </div>
              <div className="timeline-content">
                <img
                  src={item.icon}
                  alt={item.title}
                  className="timeline-icon"
                />
                <h4 style={{ color: " rgb(7, 223, 252)" }}>{item.title}</h4>
                <ul>
                  {item.description.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
                <div>
                  {item.badges.map((badge, i) => (
                    <span
                      key={i}
                      className={`badge rounded-pill bg-${badge.color} ${
                        i > 0 ? "ms-1" : ""
                      }`}
                    >
                      {badge.text}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Month7;
